import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {Getters, State} from "@/store/user/types";

const getters: GetterTree<State, RootState> & Getters = {
    loginError: state => state.error,
    loader: state => state.loader,
    userData: state => state.user_info,
    userName: state => state.user_info ? `${state.user_info.lastName} ${state.user_info.firstName} ${state.user_info.middleName}` : null,
    userPosition: state => state.user_position,
    userPositionBid: state => state.user_position_bid,
    getPasswordResetStep: state => state.reset_step
};

export default getters